var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpretorDevideIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5625V8.4375H0V6.5625H15ZM7.5 4.375C7.9144 4.375 8.31183 4.21038 8.60485 3.91735C8.89788 3.62433 9.0625 3.2269 9.0625 2.8125C9.0625 2.3981 8.89788 2.00067 8.60485 1.70765C8.31183 1.41462 7.9144 1.25 7.5 1.25C7.0856 1.25 6.68817 1.41462 6.39515 1.70765C6.10212 2.00067 5.9375 2.3981 5.9375 2.8125C5.9375 3.2269 6.10212 3.62433 6.39515 3.91735C6.68817 4.21038 7.0856 4.375 7.5 4.375ZM7.5 10.625C7.0856 10.625 6.68817 10.7896 6.39515 11.0826C6.10212 11.3757 5.9375 11.7731 5.9375 12.1875C5.9375 12.6019 6.10212 12.9993 6.39515 13.2924C6.68817 13.5854 7.0856 13.75 7.5 13.75C7.9144 13.75 8.31183 13.5854 8.60485 13.2924C8.89788 12.9993 9.0625 12.6019 9.0625 12.1875C9.0625 11.7731 8.89788 11.3757 8.60485 11.0826C8.31183 10.7896 7.9144 10.625 7.5 10.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpretorDevideIcon);
export default __webpack_public_path__ + "static/media/opretor_devide_icon.bfcc259c9c735a5d4034f4b26d927f7c.svg";
export { ForwardRef as ReactComponent };